<template>

    <v-row row justify-center>

        <fingerprint-dialog v-model="showFingerPrintLoading"></fingerprint-dialog>

        <two-factor-dialog :key="key"
                           v-model="showTwoFactorDialog"
                           :error-message="tokenError"
                           @change="codeEntered"
        ></two-factor-dialog>

    </v-row>

</template>

<script>
    import {fingerprint} from '../../../components/mixins/fingerprintMixin';
    import FingerprintDialog from "./FingerprintDialog";
    import TwoFactorDialog from "./TwoFactorDialog";
    import axios from "axios";

    export default {

        mixins: [fingerprint],

        components: {
            FingerprintDialog,
            TwoFactorDialog
        },

        data() {
            return {
                tokenFormValid: false,
                showFingerPrintLoading: false,
                showTwoFactorDialog: false,
                tokenError: null,
                key: 100
            }
        },

        methods: {
            codeEntered(value) {

                this.showTwoFactorDialog = false;

                axios.post('/login/token', {token: value})

                    .then((response) => {

                        if (response.status === 200) {
                            Bus.$emit('user-authenticated');
                        }
                    })
                    .catch((error) => {

                        // Not acceptable
                        if (error.response.status === 406) {
                            Bus.$emit('flash-message', {type: 'error', message: 'Sorry that token was not valid!'});
                            this.key++;
                            this.showTwoFactorDialog = true;
                        }

                        // User doesn't have authenticated session
                        if (error.response.status === 401) {
                            Bus.$emit('flash-message', {type: 'info', message: 'You need to authenticate first!'});
                            this.$router.push('/spa/login');
                        }
                    });
            },
            guide() {
                // Change to the token screen
                this.$router.push('/spa/authy/token');
            }
        },

        mounted() {

            this.showFingerPrintLoading = true;

            this.generateFingerprint(fingerprint => {

                axios.post('/fingerprint', {
                    'result': fingerprint.result,
                    'components': fingerprint.components
                })
                    .then(({data}) => {

                        if (data.message === "success") {
                            this.showFingerPrintLoading = false;
                            Bus.$emit('user-authenticated');
                        } else {
                            this.showFingerPrintLoading = false;
                            // Display 2FA dialog if user is not known
                            this.showTwoFactorDialog = true;

                        }
                    })
                    .catch((response) => {
                        if (response.status === '403')
                            this.$router.push('/spa/login');
                    });
            });
        },

    }
</script>
